import React from 'react';
import PropTypes from 'prop-types';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

import './tab_panels.scss';

const TabPanels = ({ activeIndex, children }) => (
  <div className="tab-panels">
    <ReactCSSTransitionGroup
      transitionName="fade-in"
      transitionEnterTimeout={350}
      transitionLeaveTimeout={350}
    >
      <div key={`panel-${activeIndex}`}>{children[activeIndex]}</div>
    </ReactCSSTransitionGroup>
  </div>
);

TabPanels.propTypes = {
  activeIndex: PropTypes.number,
  children: PropTypes.node.isRequired,
};

TabPanels.defaultProps = {
  activeIndex: 0,
};

export default TabPanels;
